import { Component } from '@angular/core';

@Component({
  selector: 'app-w25',
  standalone: true,
  imports: [],
  templateUrl: './w25.component.html',
  styleUrl: './w25.component.css'
})
export class W25Component {

}
